export interface PrayerList {
  id: string;
  name: string;
  updatedAt: string;
}

export enum PrayerType {
  THANKSGIVING = 'Thanksgiving',
  PETITION = 'Petition',
  INTERCESSION = 'Intercession',
  PRAISE = 'Praise',
  LAMENT = 'Lament',
}

export enum PrayerStatus {
  CURRENT = 'Current',
  ONGOING = 'Ongoing',
  ANSWERED = 'Answered',
}

export interface PrayerRequest {
  id: string;
  listId: string;
  requestor: string;
  date: string; // ISO string
  title: string;
  type: PrayerType;
  status: PrayerStatus;
  details: string;
  updatedAt: string;
  answeredDetails?: string;
  bibleVerseRecommendation?: string;
}

export type PrayerFilter = 'all' | PrayerStatus | PrayerType | string; // string for listId

export interface FunctionCallHandler {
    addPrayerRequest: (args: any) => Promise<string>;
    updatePrayerRequest: (args: any) => Promise<string>;
    findPrayerRequests: (args: any) => Promise<string>;
    startPrayerTime: (args: any) => Promise<string>;
    recommendAndReadVerse: (args: any) => Promise<string>;
    setFavoriteBibleVersion: (args: any) => Promise<string>;
    createPrayerList: (args: { name: string }) => Promise<string>;
    movePrayerToList: (args: { prayerTitle: string; listName: string }) => Promise<string>;
    renamePrayerRequest: (args: { oldTitle: string; newTitle: string }) => Promise<string>;
    renamePrayerList: (args: { oldName: string; newName: string }) => Promise<string>;
    deletePrayerRequest: (args: { title: string }) => Promise<string>;
    deletePrayerList: (args: { name: string }) => Promise<string>;
}

// Add types for the PWA installation prompt event
declare global {
  interface WindowEventMap {
    beforeinstallprompt: BeforeInstallPromptEvent;
  }
  interface BeforeInstallPromptEvent extends Event {
    readonly platforms: string[];
    readonly userChoice: Promise<{
      outcome: 'accepted' | 'dismissed';
      platform: string;
    }>;
    prompt(): Promise<void>;
  }

  // FIX: Add types for Google API client (gapi) to resolve namespace errors.
  namespace gapi {
    namespace auth2 {
      interface BasicProfile {
        getId(): string;
        getName(): string;
        getGivenName(): string;
        getFamilyName(): string;
        getImageUrl(): string;
        getEmail(): string;
      }
    }
  }

  const gapi: any;
}
